import React, { } from 'react';
import { GridView, SimpleView } from '@digital/ui';
import { ReportCicloOrcamentario } from '../../api/relatorios';
import { Collapse, Icon } from 'antd';
import CurvaPluriAnualGrafico from './curvaPluriAnualGrafico';
const { Panel } = Collapse;

interface GraficoCurvaPluriAnualProps {
  relatorio: ReportCicloOrcamentario;
  carregarTabela: boolean;
  exportarCurvaEconomicaPluriAnual?: boolean;
  projetoId?: string;
  contaResultado?: boolean;
}

const GraficoCurvaPluriAnual = (
  {
    relatorio,
    carregarTabela,
    exportarCurvaEconomicaPluriAnual,
    projetoId,
    contaResultado
  }: GraficoCurvaPluriAnualProps) => {


  return (
    <SimpleView>
      <GridView noform>
        <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="1" header="Gráfico" style={{ border: 0 }}>

            <CurvaPluriAnualGrafico
              relatorio={relatorio}
              carregarTabela={carregarTabela}
              exportarCurvaEconomicaPluriAnual={exportarCurvaEconomicaPluriAnual}
              projetoId={projetoId}
              contaResultado={contaResultado}
            />

          </Panel>
        </Collapse>
      </GridView>
    </SimpleView>
  );
};

export default GraficoCurvaPluriAnual;
